import { defineStore } from "pinia";
import { computed, ref } from "vue";

import { asReadonly } from "@/utils/vue";

export const useMessengerStore = defineStore("messenger", () => {
  const show = ref(false);
  const unreadMessages = ref(false);
  const passiveNotification = ref(false);

  return {
    show: asReadonly(show),

    // Show the new-message bage if there are any unread messages or passive notifications (eg. new news)
    showBadge: computed(() => unreadMessages.value || passiveNotification.value),
    setShow: (visible: boolean) => (show.value = visible),
    setUnreadMessages: (unread: boolean) => (unreadMessages.value = unread),
    setPassiveNotification: (passive: boolean) => (passiveNotification.value = passive),
  };
});
